---
title: Channel EQ
description: "A channel EQ device: a low shelf, a sweepable mid bell, a high shelf, a high-pass switch and an output level, a panel with a handle on the mid band, a Web Audio engine and tools for agents."
component: true
base: base
---

<ComponentPreview styleName="base-nova" name="block-channel-eq" />

The EQ of a mixer strip, simpler than the [equalizer](/docs/components/base/equalizer): a low shelf, a mid bell you sweep, a high shelf and a high-pass for the rumble. It is a [device](/docs/devices): a state, a panel, an engine and tools, each its own file.

## Installation

<Install name="channel-eq" kind="device" />

## Controls

<DeviceControls device="channel-eq">
<Control id="highPass">Cuts everything under 80 Hz.</Control>
<Control id="lowDb">The gain of the low shelf, at 100 Hz.</Control>
<Control id="midHz">The centre of the mid bell. Drag the handle on the curve across to set it.</Control>
<Control id="midDb">The gain of the mid bell. Drag the handle up or down to set it.</Control>
<Control id="highDb">The gain of the high shelf, at 6 kHz.</Control>
<Control id="outputDb">The level of the output.</Control>
</DeviceControls>

## Panel

The panel draws the curve of the four filters and the output level, with a handle on the mid band.

<DeviceUsage name="channel-eq" />

## Engine

Create it, connect it and update it as for any device: see [The engine](/docs/devices#the-engine).

Four filters in series and an output gain, the same the curve draws. With the high-pass off, it is a 10 Hz high-pass, which passes the whole spectrum, so the curve and the sound agree. `channelEqBands(state)` gives the filters.
